import { put, PutEffect } from 'redux-saga/effects';
import { debugLog } from "../debug";

type IResponse = {
    response: {
        data: {
            messageCode: string,
            payload: any,
        };
    };
    messageCode: string;
};
type IAction = (...arg0: any) => any;
export type IFailurePutCall = (e: IResponse, action: IAction) => Generator<PutEffect<any>, void, unknown>

export function* failurePut(e: IResponse, action: IAction) {
    debugLog('saga', e);
    const messageCode: string = e.response?.data?.messageCode || e.messageCode || 'error.default_message';
    if (action) {
        if (e.response?.data?.payload) {
            yield put(action({
                messageCode,
                payload: e.response?.data?.payload,
            }));
        } else {
            yield put(action(messageCode));
        }
    }

    yield put(openNotify({ message: messageCode, type: 'FAILURE' }));
}

export const openNotify = ({ type, message }: { type: 'FAILURE', message: string }) => ({
    type: 'OPEN_NOTIFY',
    payload: { type, message },
});
